import { createRouter, createWebHistory } from 'vue-router';
import { isMobile } from '~/@func/isMobile';

let routes: any = [];

routes = [
  { name: 'notLogin', path: '/', component: () => import('./common/notLogin.vue') },
  { name: 'login', path: '/s/:urlType?/:urlKey?', component: () => import('./login/index.vue') },
  {
    name: 'sharedCompare',
    path: '/compare/:urlKey?',
    component: () => import('./compare/index.vue'),
  },

  //NotFoundページは一番最後に書く必要がある
  { name: 'notFound', path: '/:catchAll(.*)', component: () => import('./common/notFound.vue') },
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

export default router;
